"use client";
import { useEffect, useState, useTransition } from "react";
import Loading from "@/components/loading";

export default function HydrationWrapper({ children }) {
  const [mounted, setMounted] = useState(false);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    startTransition(() => {
      setMounted(true);
    });
  }, []);

  // Until the client has mounted (and the mount transition settles) show the
  // loading spinner instead of rendering nothing. Returning null left a blank
  // viewport during hydration which, on a dark-mode OS, looked like a
  // full-screen black flash on every load/route change. Server and client both
  // render <Loading/> on the first pass, so there is no hydration mismatch.
  if (!mounted || isPending) return <Loading />;

  return <>{children}</>;
}
